document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 990) return;

  const announcementSlideshow = document.querySelector('slideshow-component.announcement-bar');
  const nextButton = announcementSlideshow?.querySelector('.slider-button--next');

  if (!announcementSlideshow || !nextButton) return;

  let autoRotate;
  let isPaused = false;

  function rotate() {
    if (isPaused || document.hidden) return;

    requestAnimationFrame(() => {
      nextButton.click();
    });
  }

  function start() {
    stop();
    autoRotate = setInterval(rotate, 5000);
  }

  function stop() {
    clearInterval(autoRotate);
  }

  announcementSlideshow.addEventListener('mouseenter', () => {
    isPaused = true;
  });

  announcementSlideshow.addEventListener('mouseleave', () => {
    isPaused = false;
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stop();
    } else {
      start();
    }
  });

  start();
});